/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VolumeStatisticDto } from './volumeStatisticDto';

/**
 * Volume statistic for one requested period
 */
export interface PeriodVolumeStatisticDto {
  /**
   * Requested from time
   */
  fromTime: string;
  /**
   * Requested to time
   */
  toTime: string;
  statistics: Array<VolumeStatisticDto>;
}
